export default {
  setParametros({ commit }, payload) {
    commit("setParametros", payload)
  }
}
